export default __webpack_public_path__ + "img/avatar-placeholder.05262aba.png";